<template>
  <Layout>
    <div class="router-view">
      <BusinessType class="mx-auto max-w-md px-8 pb-8" />
    </div>
  </Layout>
</template>

<script>
import Layout from '@/router/layouts/Main'
import BusinessType from '@/components/customer/BusinessType'

export default {
  components: {
    Layout,
    BusinessType,
  },
  // Skip this if we already have the personals details
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      // But allow them to go back if they do want to edit details
      if (from.name === 'business activities' || from.name === 'quote overview' || from.name === 'business lookup') return

      const contact = vm.$store.state.contact
      if (contact.firstName && contact.lastName && contact.email) {
        vm.$router.push({ name: 'business activities' })
      }
    })
  },
}
</script>
